import React,{useState} from "react"
import { Link } from "react-router-dom";
import { masonaryData, masonaryImg } from "../data/portfolio"
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css"

export default function MesonaryPortfolio({grid, row}) {
    
    let [isOpen, setisOpen] = useState(false);
    let [currentImageIndex, setCurrentImageIndex] = useState(0);
    let [selectedCategory, setSelectedCategory] = useState(null);

    let handleMovePrev = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + masonaryImg.length - 1) % masonaryImg.length);
    };
  
    let handleMoveNext = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % masonaryImg.length);
    };
    let handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setisOpen(true);
    };
    let currentImage = masonaryImg[currentImageIndex];
  
    let matchCategory = (category) => {
        setSelectedCategory(category);
    };
    
  
    let filteredData = selectedCategory
    ? masonaryData.filter((item) => item.category === selectedCategory)
    : masonaryData;

    
  return (
    <>
     <div className="row justify-content-center">
            <div className="col-12">
                <div className="filters-group-wrap text-center">
                    <div className="filters-group">
                        <ul className="container-filter mb-0 categories-filter list-unstyled filter-options">
                            <li className={`list-inline-item categories position-relative ${selectedCategory === null ? 'active' : ''}`} onClick={()=>matchCategory(null)}>Todas</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'oficina' ? 'active' : ''}`} onClick={()=>matchCategory('oficina')}>Oficina</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'magnetica' ? 'active' : ''}`} onClick={()=>matchCategory('magnetica')} >Magnética Transcraneal</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'electrica' ? 'active' : ''}`} onClick={()=>matchCategory('electrica')}>Eléctrica Transcraneal</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'cognitiva' ? 'active' : ''}`} onClick={()=>matchCategory('cognitiva')}>Terapia Cognitiva</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className="row justify-content-center mt-4">
            <div className={grid}>
                <div id="grid" className={row}>
                    {filteredData.map((item,index)=>{
                        return(
                            <div className="mb-3" data-groups='["branding"]' key={index}>
                                <div className={`card ${item.reflejo} border-0 portfolio portfolio-masonry portfolio-primary rounded overflow-hidden m-2`}>
                                        <div className="card-img position-relative">
                                            <Link to="#" onClick={()=>handleImageClick(index)} className="lightbox">
                                                        <img src={item.image} className={`img-fluid border-0 ${item.estilo}`} alt=""  />
                                            </Link>
                                        
                                        </div>
                                        <div className="content bg-white rounded text-center p-3">
                                            <Link className="text-dark h6 mb-0 d-block title">{item.title}</Link>
                                            <small className="text-muted fw-normal mb-0">{item.name}</small>
                                        </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>  

        
                {isOpen && (
                    <Lightbox
                        mainSrc={currentImage}
                        prevSrc={masonaryImg[(currentImageIndex + masonaryImg.length - 1) % masonaryImg.length]}
                        nextSrc={masonaryImg[(currentImageIndex + 1) % masonaryImg.length]}
        
                        onCloseRequest={() => setisOpen(false)}
                        onMovePrevRequest={handleMovePrev}
                        onMoveNextRequest={handleMoveNext}
                    />
                )}
    </>
  )
}
